import { Box, Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";
import useStaticIPs from "../api/hooks/useStaticIPs";
import CustomCopyButton from "./CustomCopyButton";
import LoadingIcon from "./LoadingIcon";

const StaticIPDisplay = ({ containerWidth = "300px" }) => {
  const colors = useColors();
  const { staticIPs, isLoading, isError } = useStaticIPs();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" py={3}>
        <LoadingIcon size={25} />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">Failed to load static IP addresses</Typography>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Box>
        <Typography variant="subtitle1" gutterBottom>
          Static IP Addresses
        </Typography>
        <Typography variant="body2" color={colors.text_secondary}>
          All Breeze outbound traffic originates from these static source IPs.
          <br />
          Add them to your firewall or integration allowlists to ensure
          connectivity.
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" gap={2}>
        {staticIPs.map((ip, index) => (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              padding: "12px 16px",
              border: "1px solid " + colors.enabled_stroke,
              borderRadius: "8px",
              width: containerWidth,
            }}
          >
            <Typography variant="body2">{ip}</Typography>
            <CustomCopyButton copyTitle="IP Address" copyText={ip} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default StaticIPDisplay;
